import { Scene } from "phaser";
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";


const names = ['jiu', 'sua', 'siyeon', 'handong', 'yoohyeon', 'dami', 'gahyeon'];

let characterSelectedName;
let textError;

const objNames = {};
const objNamesMusic = {};

let gameSettings;
let defaultSettings = '1'



export default class Start extends Scene {

    constructor() {

        super({ key: "Start" });
    }

    preload() {
    }

    create() {
        const characterPreviuosSelected = localStorage.getItem('ch');


        if(characterPreviuosSelected === null || characterPreviuosSelected === undefined) {
            gameSettings = localStorage.getItem('sound');
                if (gameSettings === null) {
                    localStorage.setItem('sound', 1);
                    gameSettings = defaultSettings;
                }
    
            this.events.on(`resume`, () => {
                this.sound.mute = false;
                gameSettings = localStorage.getItem('sound');
                if(gameSettings === '0') {
                    for (const c of names) {
                        objNamesMusic[c].stop();
                    }
                }
            });
    
            this.screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 4;
    
            this.add.image(400, 290, 'menu');
    
    
            if (this.sys.game.device.os.desktop) {
                console.log("desktop")
            }
            else {
                // this.warning = this.add.text(this.screenCenterX - 90, 0, "¡ GIRA TU CELULAR DE MANERA HORIZONTAL PARA UNA MEJOR EXPERIENCIA !", { font: "10px CustomFont", fill: "#BA2A28" });
                // this.aGrid.placeAtIndex(120, this.warning);
    
                console.log("mobile")
    
                // setTimeout(() => {
                //     this.warning.destroy();
                // }, 9000);
            }
    
            // this.aGrid.showNumbers();
    
            // this.title = this.add.text(0,0, "Selecciona personaje para iniciar", { font: "50px Courier", fill: "#FFFFFF" }).setScale(0.5);
            // this.aGrid.placeAt(2,2,this.title);
            // this.aGrid.placeAtIndex(2, this.title);
    
            let startStep = 451;
            let startStepY = 168;
            // let startGrid = 37;
    
            for (const [index, name] of names.entries()) {
    
    
                if (index === 2) {
                    startStep = 451;
                    startStepY = 223;
                }
    
                if (index === 4) {
                    startStep = 451;
                    startStepY = 277;
                }
    
                if (index === 6) {
                    startStep = 478;
                    startStepY = 333;
                }
    
                startStep += 55;
    
                objNamesMusic[name] = this.sound.add(`${name}Solo`, { loop: false, volume: 0.2 });
                objNames[name] = this.physics.add.sprite(startStep, startStepY, `${name}-start`)
                    // .setScale(2)
                    .setInteractive({ useHandCursor: true })
                    .on('pointerdown', () => this.onClickSprite(objNames[name], name))
                    .on('pointerover', () => {
                        objNames[name].anims.play(`button-select-${name}`);
                        // objNames[name].setScale(1.5);
    
                    })
                    .on('pointerout', () => {
                        if (characterSelectedName !== name) {
                            objNames[name].setScale(1);
                            objNames[name].anims.stop();
                        }
                        // objNamesMusic[name].stop();
                    });
    
                // this.aGrid.placeAt(2,2, objNames[name]);
    
                // startGrid+=2;
                // this.aGrid.placeAtIndex(startGrid, objNames[name]);
    
                this.anims.create({
                    key: `button-select-${name}`,
                    frames: this.anims.generateFrameNumbers(`${name}-start`, { start: 0, end: 2 }),
                    frameRate: 5,
                    repeat: -1
                });
    
                // objNames[name].anims.play(`turn-${name}-start`);
            }

    
            this.buttonStart = this.add.image(535, 403, 'buttonPlay').setInteractive({ useHandCursor: true })
                .on('pointerdown', () => this.goToGame());

            this.buttonAbout = this.add.image(266, 403, 'buttonAbout').setInteractive({ useHandCursor: true })
                .on('pointerdown', () => this.goToAbout());
            //  new Button(450, 390, '     ', this, null, null, () => this.goToGame());
            // this.aGrid.placeAtIndex(86, this.buttonStart);

            this.buttonStart.setVisible(false);
    
            this.buttonFullscreen = new FullScreen(this);
            this.buttonSettings = new PauseButton(this);

            this.textContact = this.add.text(280, 20, "CONTACT: contact@deukae.com", { font: "26px CustomFont", fill: "#fff",stroke: "#000", strokeThickness: 1 }).setVisible(true);

        } else {
            this.scene.start('Hallway', { characterSelected: names[characterPreviuosSelected] });
        }


    }

    goToGame() {
        if (!characterSelectedName) {

            if (this.warning && this.warning.visible) {
                this.warning.setVisible(false);
            }

            textError = this.add.text(280, 20, "SELECCIONA UN PERSONAJE", { font: "26px CustomFont", fill: "#fff",stroke: "#000", strokeThickness: 1 });
            // this.aGrid.placeAtIndex(109,textError);

        } else {
            localStorage.setItem('ch', names.findIndex(n => n === characterSelectedName));
            objNamesMusic[characterSelectedName].stop();
            this.scene.start('Hallway', { characterSelected: characterSelectedName });
        }
    }
    
    goToAbout() {
        this.scene.start('About');
    }

    onClickSprite(object, name) {

        characterSelectedName = name;
        this.buttonStart.setVisible(true);

        objNames[name].setScale(1.5);

        object.anims.play(`button-select-${name}`);
        if (gameSettings === '1') {
            objNamesMusic[name].play();
        }

        if (textError) {
            textError.destroy();
        }

        for (const c of names) {
            if (c !== name) {
                objNames[c].setScale(1);
                objNames[c].anims.stop();
                objNamesMusic[c].stop();

            }
        }
    }

    update() {
    }
}